import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {CaseFormsService} from '../case-forms.service';
import {MessagingService} from '../../../services/messaging.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormConfigurationModel} from '../../../models/forms/form-configuration.model';
import {TdoTableSelectionEvent} from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {PatientCaseWorkItemFormDataModel} from '../../../models/forms/data/patient-case-work-item-form-data.model';
import {DataPatientCaseWorkItemModel} from '../../../models/accountsReceivable/data-patient-case-work-item.model';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {DataPatientCaseWorkItemToothModel} from '../../../models/teeth/data-patient-case-work-item-tooth.model';
import {TdoTableV2Component} from '../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';

@Component({
  selector: 'app-case-procedure-add-form',
  templateUrl: './case-procedure-add-form.component.html',
  styleUrls: ['./case-procedure-add-form.component.scss']
})
export class CaseProcedureAddFormComponent implements OnInit {
  @ViewChild('procedureTable') procedureTable: TdoTableV2Component;
  @ViewChild('allTable') allTable: TdoTableV2Component;

  searchPredicate: (data: any, filter: string) => boolean;
  caseProcedureName: string;
  caseWorkItemID: string;
  caseProcedureID: string;
  dFormsAll: FormConfigurationModel[] = [];
  dFormsProcedure: FormConfigurationModel[] = [];
  dFormIDsAdded: string[] = [];
  dFormsSelected: FormConfigurationModel[] = [];
  isLoading: boolean;
  caseWorkItem: DataPatientCaseWorkItemModel;
  isShowInReview: boolean = false;

  selectionSection: number = 0;
  selectedIndex: number = 0;
  formsTabRightLabel: string = 'All Forms';
  locid: number;

  selectedDataPatientCaseWorkItemTeeth: string[] = [];

  constructor(
    public dialogRef: MatDialogRef<CaseProcedureAddFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private caseService: CaseFormsService,
    private messagingService: MessagingService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    )
  {
    this.searchPredicate = (searchData: FormConfigurationModel, filter: string) => {
      if ((!searchData.DFormName ? '' : searchData.DFormName).toLowerCase().includes(filter)) {
        return true;
      }
      else {
        return false;
      }
    };
  }

  ngOnInit() {
    this.caseWorkItem = this.data.CaseWorkItem;
    this.selectionSection = this.data.SelectionSection;

    if (this.selectionSection === 0) {
      this.formsTabRightLabel = 'Available Forms';
      this.loadForGeneralForms();
    }
    else {
      this.loadForProcedure();
    }
  }

  async loadForProcedure() {

    this.caseWorkItemID = this.data.CaseWorkItemID;
    this.caseProcedureName = this.data.CaseProcedureName;
    this.isLoading = true;

    // get all enums
    const promises: any[] = [
      this.caseService.getProcedureDFormsByCaseWorkItem(this.caseWorkItemID).toPromise(),
      this.caseService.getDFormIDsByCaseWorkItem(this.caseWorkItemID).toPromise()
    ];

    try {
      const results: any[] = await Promise.all(promises);
      this.dFormsProcedure = results[0];
      this.dFormIDsAdded = results[1];
      this.loadForms();
      // remove any forms (from the All Forms) that are tied to a caseworkitem in cfgCaseProcedureForm

      this.isLoading = false;
    } catch (err) {
      this.isLoading = false;
      this.showMessage('Something went wrong', 'Error');
    }

    if (this.caseWorkItem.dataPatientCaseItemTeeth.length === 1) {
      this.selectedDataPatientCaseWorkItemTeeth.push(this.caseWorkItem.dataPatientCaseItemTeeth[0].CaseWorkItemToothId);
    }
  }

  loadForms() {
    this.caseService.getCfgDFormsAll(this.isShowInReview).subscribe((forms) => {
      this.dFormsAll = forms;

      this.dFormsProcedure.forEach(form => {
        this.dFormsAll = this.dFormsAll.filter(a => a.DFormId.toLowerCase() !== form.DFormId.toLowerCase());
      });

      if (this.selectedIndex === 0) {
        this.procedureTable.updateData(this.dFormsProcedure);
      } else {
        this.allTable.updateData(this.dFormsAll);
      }
    });
  }

  async loadForGeneralForms() {

    this.caseWorkItemID = this.data.CaseWorkItemsPatientFormsCaseWorkItemID;
    const addedGeneralPatientForms: PatientCaseWorkItemFormDataModel[] = this.data.AddedGeneralPatientForms;
    this.locid = this.data.LOCID;
    this.isLoading = true;

    // get all enums
    const promises: any[] = [
      this.caseService.getCfgSchedulePatientFormsAll(this.locid).toPromise(),
    ];

    try {
      const results: any[] = await Promise.all(promises);
      this.dFormsAll = results[0];

      // remove any forms (from the All Forms) that are already added
      addedGeneralPatientForms.forEach(form => {
        this.dFormsAll = this.dFormsAll.filter(a => a.DFormId.toLowerCase() !== form.DFormId.toLowerCase());
      });

      this.isLoading = false;
    } catch (err) {
      this.isLoading = false;
      this.showMessage('Something went wrong', 'Error');
    }
  }

  showMessage(type, message) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  close(payload) {
    this.dialogRef.close(payload);
  }

  onRowSelected($event: TdoTableSelectionEvent) {
    if ($event.isSelected) {
      this.dFormsSelected.push($event.model);
    }
    else {
      this.dFormsSelected = this.dFormsSelected.filter(a =>
        a.DFormId.toLowerCase() !== $event.model.DFormId.toLowerCase()
      );
    }
  }

  addForms() {
    if(this.dFormsSelected.find(x => x.isToothRequired === true) && this.selectedDataPatientCaseWorkItemTeeth.length < 1){
      this.showMessage('Add Form', 'Please select tooth / teeth:');
      return;
    }
    this.isLoading = true;
    this.caseService.addFormsToCaseWorkItem(this.caseWorkItemID, this.dFormsSelected, this.selectedDataPatientCaseWorkItemTeeth)
      .subscribe((response: any) => {
        this.isLoading = false;
        this.dialogRef.close(response);
        this.showMessage('Success', 'Form(s) added');
      }, err => {
        this.isLoading = false;
        this.showMessage('Error', 'Problem adding forms');
      });
  }

  onSelectedTeethChange(event: MatCheckboxChange, caseWorkItemTooth: DataPatientCaseWorkItemToothModel) {
    if (event.checked) {
      if (!this.selectedDataPatientCaseWorkItemTeeth.includes(caseWorkItemTooth.CaseWorkItemToothId)) {
        this.selectedDataPatientCaseWorkItemTeeth.push(caseWorkItemTooth.CaseWorkItemToothId);
      }
    } else {
      const idx = this.selectedDataPatientCaseWorkItemTeeth.findIndex(p => p === caseWorkItemTooth.CaseWorkItemToothId);
      if (idx > -1) {
        this.selectedDataPatientCaseWorkItemTeeth.splice(idx, 1);
      }
    }
  }


  onIsShowInReviewChange(event: MatCheckboxChange) {
    this.isShowInReview = event.checked;
    this.loadForms();
  }

  onSelectedIndexChange(event: number) {
    this.selectedIndex = event;
    if (this.selectedIndex === 0) {
      this.procedureTable.updateData(this.dFormsProcedure);
    } else {
      this.allTable.updateData(this.dFormsAll);
    }
  }

  isChecked(cb: DataPatientCaseWorkItemToothModel) {
    return this.selectedDataPatientCaseWorkItemTeeth.includes(cb.CaseWorkItemToothId);
  }
}
